module.exports = __webpack_public_path__ + "static/media/p5a5.bc4feb51.wav";